import get from 'lodash.get';

export const geImageURLDesktop = (packageProps) => {
  const imageUrlDesktop = get(packageProps, 'content.metadata.imageUrlDesktop');
  return imageUrlDesktop;
};

export const getImageURLMobile = (packageProps) => {
  const imageUrlMobile = get(packageProps, 'content.metadata.imageUrlMobile');
  return imageUrlMobile;
};

export const getPackageID = (packageProps) => {
  const packageID = get(packageProps, 'content.id');
  return packageID;
};

export const transformPackagePropsToUIProps = (packageProps) => {
  const imageUrlDesktop = geImageURLDesktop(packageProps);
  const imageUrlMobile = getImageURLMobile(packageProps);
  const packageID = getPackageID(packageProps);

  return {
    imageUrlDesktop,
    imageUrlMobile,
    packageID,
  };
};
